<dx-popup [showTitle]="true" title="Sostituisci articolo obsoleto" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
    [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()" height="300px" width="600px">
    
    <div class="row">
        
        <div class="col-12">
            <h4>Articolo da sostituire</h4>
            <div class="dx-field">
                <div class="dx-field-label"><b>Codice</b></div>
                <div class="dx-field-value">
                    {{articolo?.codice}}
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label"><b>Descrizione</b></div>
                <div class="dx-field-value">
                    {{articolo?.descrizione}} 
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label"><b>Taglia</b></div>
                <div class="dx-field-value">
                    {{articolo?.taglia}} 
                </div>
            </div>
        </div>
    </div>
    <hr style="margin-top:10px;margin-bottom: 10px;">
    <div class="row"> 
            
        <div class="col-12">

            <div class="dx-field">
                <div class="dx-field-label"><b>Articolo sostitutivo</b></div>
                <div class="dx-field-value">
                    <dx-lookup 
                        placeholder="Articolo sostitutivo"
                        valueExpr="id" 
                        [dataSource]="listArticoli"
                        [searchEnabled]="true" 
                        [(value)]="idArticoloSostitutivo" 
                        [displayExpr]="getArticoloDisplayExpr">
                </dx-lookup>
                </div>
            </div>
               
        </div>
    </div>
    <hr style="margin-top:10px;margin-bottom: 10px;">
    <div class="row">        
        <div class="col-6 offset-6">
            <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="onSalvaClick()" style="width: 150px; margin-right: 10px;">
            </dx-button>       
            <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
            </dx-button>      
        </div>         
    </div>
     
    
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" 
    [(visible)]="loadPanelVisible" 
    [showIndicator]="true" 
    [showPane]="true" 
    [shading]="true"
    [hideOnOutsideClick]="false">
</dx-load-panel>